import { useEffect } from 'react';

import { useCampaignTracking } from '#src/app/shared/hooks/campaignTracking';

export function useContactDecisionMakerPaintedDoor() {
	const { track } = useCampaignTracking();

	useEffect(() => {
		track('campaign_action_psf_contact_decision_maker_view');
	}, [track]);
}
